import { BlogCategory, BlogCategoryDocument, ElasticSearchResponse } from '@shared/services/elastic-search/models';

export const blogCategoriesSerializer = (blogCategories: ElasticSearchResponse<BlogCategoryDocument>): BlogCategory[] =>
  blogCategories.hits.hits.map((blogCategory) => {
    const source = blogCategory._source;
    return {
      level1Category: source.parent_term_name?.[0] ?? '',
      level2Category: source.term_name?.[0] ?? '',
      url: source.url?.[0] ?? '',
    };
  });
